import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const TEMPLATE_DESCRIPTION_TYPES = [
  "short",
  "bodyweight",
  "nutrition",
  "steps",
  "sleep",
  "hrv",
  "bodyFatPercentage",
  "restingHeartRate",
];

const QuestionShort = ({ description, questionType }) => {
  const { t } = useTranslation("athlete-portal");
  const text =
    questionType && TEMPLATE_DESCRIPTION_TYPES.includes(questionType)
      ? t(`questionTypeDefaults.${questionType}Description`)
      : description;
  return <span className="question-description-short">{text}</span>;
};

export const CreateQuestionShortHeader = ({ data, setData }) => {
  const { t } = useTranslation("athlete-portal");
  const [title, setTitle] = useState(data.title || "");

  const handleChange = (e) => {
    const { value } = e.target;

    setData((previousState) => ({
      ...previousState,
      title: value,
    }));

    setTitle(value);
  };

  return (
    <input
      type="text"
      name="question-short"
      placeholder={t("questionShort.placeholder")}
      className="question-input"
      value={title}
      onChange={handleChange}
      autoFocus
    />
  );
};

export const CreateQuestionShortBody = ({ placeholder }) => {
  return (
    <div className="answer-short-body">
      <input
        type="text"
        name="question-short"
        placeholder={placeholder}
        className="answer-input"
        disabled
      />
      <div className="no-buttons"></div>
    </div>
  );
};

export const CreateQuestionShortHeaderNoInput = ({ title }) => {
  return <span className="answer-title">{title}</span>;
};

export default QuestionShort;
